import { render, staticRenderFns } from "./TrainingCertDialog.vue?vue&type=template&id=b52f65ba"
import script from "./TrainingCertDialog.vue?vue&type=script&lang=js"
export * from "./TrainingCertDialog.vue?vue&type=script&lang=js"
import style0 from "./TrainingCertDialog.vue?vue&type=style&index=0&id=b52f65ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports